export const getParentQueryParams = () => {
	let value = "";
	console.log('DOCUMENT REFERRER', document.referrer);
	if (document.referrer) {
		value = getParamValue("ticker", document.referrer).toUpperCase();
	}
	return { ticker: value };
};

export const getDocumentQueryParams = () => {
	let query = window.location.hash;
	let tickerValue = "";
	let lookupValue = "";
	if (query) {
		tickerValue = getParamValue("ticker", query).toUpperCase();
		lookupValue = getParamValue("lookup", query);
	}
	return { ticker: tickerValue, lookup: lookupValue };
};

export const getParamValue = (paramName: string, url: string) => {
	if (url) {
		let query = url.split("?")[1]; //get querystring
		let qArray = query && query.split('&'); //get key-value pairs
		if (qArray) {
			for (let i = 0; i < qArray.length; i++) {
				let pArr = qArray[i].split('='); //split key and value
				if (pArr[0] === paramName) {
					return decodeURIComponent(pArr[1]);
				}
			}
		}
	}
	return "";
}

export const filterUserInput = (input: string) => {
	let tickerlength = input;
	let filteredTicker = input;
	let redirectLink = '';

	if (filteredTicker.indexOf(".") >= 0) {
		let temp = filteredTicker.split(".");
		tickerlength = temp[0];
		if (stock_ext_array.indexOf(temp[1]) === -1 && temp[1] !== "") {
			filteredTicker = tickerlength;
		}
	}
	if (filteredTicker.indexOf("-") >= 0) {
		let temp = filteredTicker.split("-");
		tickerlength = temp[0];
		if (stock_ext_array.indexOf(temp[1]) === -1 && stock_ext_array2.indexOf(temp[1]) === -1) {
			filteredTicker = tickerlength;
		} else {
				if (stock_ext_array2.indexOf(temp[1]) !== -1) {
					filteredTicker = temp[0] + "-" + temp[1];
				} else {
					filteredTicker = temp[0] + "." + temp[1];
				}
		}
	}
	if (tickerlength.length > 4 && stock_ticker_array.indexOf(filteredTicker) === -1 && tickerlength.indexOf(":") === -1) {
		redirectLink = "https://finance.yahoo.com/quote/" + encodeURIComponent(filteredTicker);
		// console.log(encodeURIComponent(filteredTicker));
	}
	return [filteredTicker, redirectLink];
};

const stock_ext_array = [ "A", "B", "C", "U", "UN" ];

const stock_ext_array2 = [ "PE" ];

const stock_ticker_array = [
"AAGIY",
"AAIGF",
"ACBFF",
"ADDYY",
"ALSMY",
"APHQF",
"ASBFY",
"ASHTY",
"ASOMY",
"AZIHY",
"BAESY",
"BASFY",
"BAYRY",
"BBT/PF",
"BURBY",
"BZLFY",
"CAHPF",
"CICHF",
"CLPBY",
"CMCSA",
"CMPGY",
"CMWAY",
"CNSWF",
"CNTTF",
"COIHY",
"DANOY",
"DISCA",
"DISCB",
"DISCK",
"DTEGY",
"EADSY",
"ENGGY",
"ESLOY",
"EXPGY",
"FANUY",
"FSNUY",
"GBLBF",
"GBLBY",
"GCTAF",
"GCTAY",
"GLNCY",
"GOOGL",
"HBAYF",
"HESAY",
"HLMAF",
"HOKCY",
"HSNGY",
"IDCBY",
"IMBBY",
"IKTSY",
"ITHUF",
"JMPLY",
"KRYAY",
"KYCCF",
"LBRDA",
"LBRDB",
"LBRDK",
"LBTYA",
"LBTYK",
"LDSVF",
"LHSIF",
"LILAK",
"LKREF",
"LNVGY",
"LRLCY",
"LSXMK",
"LVMUY",
"LUKOY",
"MGPUF",
"MONOY",
"MTNOY",
"MTRAF",
"MTSFY",
"NOVKY",
"NPSNY",
"NRDBY",
"NSANY",
"NSRGY",
"NTDOY",
"NVZMY",
"NXGPY",
"OGZPY",
"PDRDY",
"PDYPY",
"PGENY",
"PPRUY",
"PRDRY",
"RBGLY",
"RDEIY",
"RHHBY",
"RUSHA",
"SEKEF",
"SFTBY",
"SGPYY",
"SGBAF",
"SHLDQ",
"SIEGY",
"SKVKY",
"SKYAY",
"SSEZY",
"SSNLF",
"STBFY",
"TCEHY",
"TELNY",
"TGODF",
"TKPYY",
"TLSNY",
"TOELY",
"TSCDY",
"TWMJF",
"VLKAY",
"VREYF",
"VWAGY",
"VWDRY",
"WFTBF",
"WTBDY",
"WTKWY",
"YASKY",
// UK tickers
// "LSE:BOE",
// "LSE:EZJ",
// "LSE:FUTR",
// "LSE:SHEL",
// "LSE:TSCO",
];
